import {asyncType} from 'redux/helpers';

export const backupKey = 'backup';

export default {
   BACKUP: asyncType(`${backupKey}/BACKUP`),
   MERGE: asyncType(`${backupKey}/MERGE`),
   RESTORE: asyncType(`${backupKey}/RESTORE`),

   GET_DEFAULT_DIR: asyncType(`${backupKey}/GET_DEFAULT_DIR`),
   IS_ENCRYPTED: asyncType(`${backupKey}/IS_ENCRYPTED`),
   PARSE_MERGE: asyncType(`${backupKey}/PARSE_MERGE`),

   LOCK_FOR_MERGE: asyncType(`${backupKey}/LOCK_FOR_MERGE`),
   LOCK_FOR_RESTORE: asyncType(`${backupKey}/LOCK_FOR_RESTORE`),
   UNLOCK: asyncType(`${backupKey}/UNLOCK`),

   PREPARE_FOR_RESTORE: asyncType(`${backupKey}/PREPARE_FOR_RESTORE`),
   SUSPEND_RESTORE: asyncType(`${backupKey}/SUSPEND_RESTORE`),
   RELEASE_RESTORE: asyncType(`${backupKey}/RELEASE_RESTORE`),

   GET_JOBS_RUNNING: asyncType(`${backupKey}/GET_JOBS_RUNNING`),

   EXIT: asyncType(`${backupKey}/EXIT`),
   //    : `${backupKey}/`,
};
